import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { setMeta } from "@/hooks/useSEO";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import WhyHMBeacon from "@/pages/WhyHMBeacon";
import Capabilities from "@/pages/Capabilities";
import Network from "@/pages/Network";
import Industries from "@/pages/Industries";
import Perspectives from "@/pages/Perspectives";
import PerspectiveDetail from "@/pages/PerspectiveDetail";
import Evidence from "@/pages/Evidence";
import EvidenceDetail from "@/pages/EvidenceDetail";
import Contact from "@/pages/Contact";

function Site({ children }) {
  return (
    <SmoothScroll>
      <Layout>{children}</Layout>
    </SmoothScroll>
  );
}

const SEO = {
  "/": ["HM Beacon — Building Authority Through Strategic Visibility", "HM Beacon is a strategic visibility partner that maps the ecosystems around your business and orchestrates the visibility opportunities that build authority."],
  "/why": ["Why HM Beacon — Strategic Visibility Partner", "We build authority, not just visibility. HM Beacon positions organizations within the ecosystems where industries are shaped."],
  "/capabilities": ["Capabilities — HM Beacon", "The platforms that build authority: executive positioning, industry access, recognition and visibility strategy."],
  "/network": ["Our Global Visibility Network — HM Beacon", "Connected to the world's leading visibility ecosystems across premium business media, executive forums, conferences and recognition platforms."],
  "/industries": ["Industries — HM Beacon", "Influence is industry-specific. HM Beacon helps organizations become visible within the networks that shape their sector."],
  "/evidence": ["Client Evidence — HM Beacon", "A documented portfolio of executive and organizational visibility engagements across media, speaking platforms and industry recognition."],
  "/perspectives": ["Visibility Intelligence — HM Beacon", "Perspectives on the platforms, ecosystems and conversations shaping where business influence is built."],
  "/contact": ["Map Your Visibility — HM Beacon", "A short strategic diagnostic to map the ecosystems and visibility opportunities that matter for your company and its leaders."],
};

function RouteSEO() {
  const { pathname } = useLocation();
  useEffect(() => {
    const key = pathname.replace(/\/+$/, "") || "/";
    const m = SEO[key];
    if (m) { document.title = m[0]; setMeta("description", m[1]); }
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const t = setTimeout(() => document.documentElement.classList.add("motion-done"), 2200);
    return () => clearTimeout(t);
  }, []);
  return (
    <BrowserRouter>
      <RouteSEO />
      <Routes>
        <Route path="/" element={<Site><Home /></Site>} />
        <Route path="/why" element={<Site><WhyHMBeacon /></Site>} />
        <Route path="/capabilities" element={<Site><Capabilities /></Site>} />
        <Route path="/network" element={<Site><Network /></Site>} />
        <Route path="/industries" element={<Site><Industries /></Site>} />
        <Route path="/perspectives" element={<Site><Perspectives /></Site>} />
        <Route path="/perspectives/:slug" element={<Site><PerspectiveDetail /></Site>} />
        <Route path="/evidence" element={<Site><Evidence /></Site>} />
        <Route path="/evidence/:slug" element={<Site><EvidenceDetail /></Site>} />
        <Route path="/contact" element={<Site><Contact /></Site>} />
        <Route path="*" element={<Site><Home /></Site>} />
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
